import posthog from "posthog-js";
import { POSTHOG_KEY } from "../../env";

let initialized = false;

export function initializePostHog() {
  if (initialized) return posthog;
  initialized = true;

  posthog.init(POSTHOG_KEY || "", {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only",
  });
  return posthog;
}
